import service from '@/utils/request'

export function addBusinessassociation (data) {
  return service({
    url: '/service/admin/add_businessassociation',
    method: 'post',
    data
  })
}
export function editBusinessassociation (data) {
  return service({
    url: '/service/admin/edit_businessassociation',
    method: 'post',
    data
  })
}
